import {enter, toggle} from 'el-transition'
import {Modal} from '../Modules/Modal';

export default {
    init() {
        const loadingScreen = document.getElementById('loading-screen')
        window.onload = function () {

            if (loadingScreen) {
                setTimeout(function () {

                    loadingScreen.style.opacity = '0';
                    document.body.style.overflow = 'auto';
                }, 4650);
                setTimeout(function () {

                        loadingScreen.style.display = 'none';
                        document.body.className += ' loaded';
                }, 4900);
            }
        };

        const dropdownMenu = document.getElementById('dropdown-menu')
        const dropdownBtn = document.getElementById('dropdown-btn')
        const menuItemOne = document.getElementById('item1')
        const menuItemTwo = document.getElementById('item2')
        const menuItemThree = document.getElementById('item3')

        function toggleDropdownMenu()
        {

            dropdownBtn.classList.toggle('is_open');
            toggle(dropdownMenu)
            enter(menuItemOne)
            enter(menuItemTwo)
            enter(menuItemThree)
        }

        dropdownBtn.addEventListener('click', toggleDropdownMenu)

        new Modal();

        $('#resource-slider').slick({
            dots: false,
                arrows: true,
                slidesToShow: 3,
                infinite: true,
                slidesToScroll: 6,
                centerMode: true,
                initialSlide: 1,
                centerPadding: false,
                nextArrow: document.getElementById('resource-next'),
                prevArrow: document.getElementById('resource-previous'),
                responsive: [

                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        infinite: true,
                    },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    slidesToShow: 2,
                    infinite: true,
                },
            },
            {
                breakpoint: 500,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    infinite: true,
                  initialSlide: 0,
                },
            },
            ],
        });


    $('.related-slider, .collaboration-slider').slick({
        arrows: true,
        slidesToShow: 3,
        infinite: false,
        slidesToScroll: 6,
        centerMode: true,
        initialSlide: 1,
        centerPadding: false,
        nextArrow: document.getElementById('btn-next'),
        prevArrow: document.getElementById('btn-previous'),
        responsive: [
        {
            breakpoint: 1580,
            settings: {
                slidesToShow: 3,
                infinite: false,
            },
        },
        {
            breakpoint: 1380,
            settings: {
                slidesToShow: 2,
                infinite: false,
            },
        },
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 2,
              infinite: true,
            },
          },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
              infinite: true,
            },
        },
        {
            breakpoint: 768,
            settings: {
                arrows: false,
                slidesToShow: 2,
              infinite: true,
                // centerPadding: '40px',
            },
        },
        {
            breakpoint: 640,
            settings: {
                arrows: false,
                slidesToShow: 1,
              infinite: true,
              initialSlide: 0,
                // infinite: true,
                // centerPadding: '60px',
            },
        },
        ],
        });


    },
    finalize() {


    },
    };



// WEBPACK FOOTER //
// ./scripts/routes/common.js